"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const BioPhChTabs_vue_1 = __importDefault(require("@becrop/components/Results/Common/BioPhChTabs.vue"));
const MapSideBarPanel_vue_1 = __importDefault(require("./MapSideBarPanel.vue"));
const GuideTeaser_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/GuideTeaser.vue"));
const OptimalRangeLegend_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/OptimalRangeLegend.vue"));
const UpgradeTeaser_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/UpgradeTeaser.vue"));
let MapSideBarPanelMetricsScaffold = class MapSideBarPanelMetricsScaffold extends vue_property_decorator_1.Vue {
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get phchMetrics() {
        return [
            {
                'label': 'Nitrate-Nitrogen',
                'test': 'NO3-N',
            },
            {
                'label': 'Electrical Conductivity',
                'test': 'ECe (1:1)',
            },
            {
                'label': 'Sulfur',
                'test': 'S (H3A)',
            },
            {
                'label': 'Sodium',
                'test': 'Na (H3A)',
            },
            {
                'label': 'Phosphorus',
                'test': 'P (H3A)',
            },
            {
                'label': 'Potassium',
                'test': 'K (H3A)',
            },
            {
                'label': 'Calcium',
                'test': 'Ca (H3A)',
            },
            {
                'label': 'Magnesium',
                'test': 'Mg (H3A)',
            },
            {
                'label': 'Ammonium-Nitrogen',
                'test': 'NH4-N (H3A)',
            },
            {
                'label': 'Iron',
                'test': 'Fe (H3A)',
            },
            {
                'label': 'Organic Carbon, Total',
                'test': 'H2O-Org. C',
            }
        ];
    }
    get metricBlocks() {
        if (this.mode === 'single') {
            if (this.dimension === 'bio') {
                return [
                    trans('metrics.categories_in_table.nutrition'),
                    trans('metrics.categories_in_table.carbon_pathways'),
                    trans('metrics.categories_in_table.diseases_and_biocontrol'),
                    trans('metrics.categories_in_table.microbial_phytohormone'),
                    trans('metrics.categories_in_table.stress_adaptation'),
                    trans('metrics.categories_in_table.global_indexes'),
                    trans('metrics.categories_in_table.biological_soil_quality'),
                ];
            }
            if (this.dimension === 'phch') {
                /*                 return this.mainProjectDelivery.phchBlocks.filter((c: BeCropMetricsBlock) => c.metrics.length > 0); */
                return [];
            }
        }
    }
    switchDimension(k) {
        this.$emit('switchDimension', k);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], MapSideBarPanelMetricsScaffold.prototype, "currentFarm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'single' })
], MapSideBarPanelMetricsScaffold.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'bio' })
], MapSideBarPanelMetricsScaffold.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBarPanelMetricsScaffold.prototype, "theme", void 0);
MapSideBarPanelMetricsScaffold = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Search: bmk_ui_framework_1.Search,
            Separator: bmk_ui_framework_1.Separator,
            MapSideBarPanel: MapSideBarPanel_vue_1.default,
            CheckBox: bmk_ui_framework_1.CheckBox,
            BioPhChTabs: BioPhChTabs_vue_1.default,
            Loading: bmk_ui_framework_1.Loading,
            ViewZero: bmk_ui_framework_1.ViewZero,
            PhChIcon: bmk_ui_framework_1.PhChIcon,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            Button: bmk_ui_framework_1.Button,
            OptimalRangeLegend: OptimalRangeLegend_vue_1.default,
            GuideTeaser: GuideTeaser_vue_1.default,
            UpgradeTeaser: UpgradeTeaser_vue_1.default
        },
    })
], MapSideBarPanelMetricsScaffold);
exports.default = MapSideBarPanelMetricsScaffold;
